/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/lib/core.js');
require('components/lib/filter.js');
require('components/lib/directive.js');
require('components/lib/transition.js');

const commonComponent = require('components/layout/common-component/common-component');
const ajaxHttp = require('appUtil/ajaxHttp')

const { apiPath } = require('appService/api');

require('./app.scss');
const template = require('./app.tpl');

module.exports = {
  template,

  components: {
    "common-component": commonComponent
  }
}




// WEBPACK FOOTER //
// ./src/appBackend/app/app.js